<a
  dropdownToggle
  class="nav-link"
  href="javascript:void(0)"
  role="button"
  aria-haspopup="true"
  aria-expanded="false"
  [class.dropdown-triangle]="showTriangle"
  (focusout)="focusOutFunction()"
  (click)="linkClick()"
  >{{ linkText() }}</a
>
